export const TOKEN = 'token';
export const DASHBOARDS = 'dashboards';
export const LAST_ACTIVE_DASHBOARD_TAB = 'lastActiveDashboardTab';
export const ADVANCED_FILTER = 'advancedFilter';
export const CASE_FORMS = 'caseForms';
export const CASE_FORMS_SECTIONS_STATE = 'caseFormsSectionsState';
